package com.r_estrategica.redacaoestrategica.ui

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.Send
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.Search
import androidx.compose.material.icons.rounded.AccountBalance
import androidx.compose.material.icons.rounded.ArrowBack
import androidx.compose.material.icons.rounded.ArrowForward
import androidx.compose.material.icons.rounded.Groups
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.r_estrategica.redacaoestrategica.data.*

// --- MODELO DE DADOS APRIMORADO ---
data class PassoIntervencao(
    val label: String,
    val keyElemento: String,
    val keyDetalhamento: String,
    val placeholderElemento: String,
    val placeholderDetalhamento: String,
    val sugestoesElemento: List<String>,
    val sugestoesDetalhamento: List<String>,
    val tooltip: String
)

@OptIn(ExperimentalMaterial3Api::class, ExperimentalLayoutApi::class)
@Composable
fun TelaGeradorIntervencao(
    aoClicarVoltar: () -> Unit,
    aoClicarAbrirBancoAgentes: () -> Unit,
    aoEnviarParaCorrecao: (String) -> Unit,
    agenteSelecionado: String? = null,
    corPrimaria: Color = Color(0xFF1E88E5)
) {
    val clipboardManager = LocalClipboardManager.current
    val scrollState = rememberScrollState()

    var passoAtual by remember { mutableIntStateOf(0) }

    val dadosFormulario = remember { mutableStateMapOf(
        "agente" to "", "det_agente" to "",
        "acao" to "", "det_acao" to "",
        "meio" to "", "det_meio" to "",
        "efeito" to "", "det_efeito" to ""
    ) }

    LaunchedEffect(agenteSelecionado) {
        if (!agenteSelecionado.isNullOrBlank()) {
            dadosFormulario["agente"] = agenteSelecionado
        }
    }

    val passos = listOf(
        PassoIntervencao(
            label = "1. Agente (Quem?)", keyElemento = "agente", keyDetalhamento = "det_agente",
            placeholderElemento = "Ex: Governo Federal...", placeholderDetalhamento = "Ex: órgão responsável por...",
            sugestoesElemento = listOf("Governo Federal", "Ministério da Educação (MEC)", "Mídia", "ONGs", "Iniciativa Privada", "Poder Legislativo"),
            sugestoesDetalhamento = listOf("órgão máximo responsável por essa jurisdição", "instituição que possui o dever constitucional de atuar nessa área", "entidade com grande poder de representação e mobilização social", "grande formadora de opinião e considerada o 'quarto poder'", "setor detentor de grande parte do capital financeiro e de inovação"),
            tooltip = "Quem executará a ação?"
        ),
        PassoIntervencao(
            label = "2. Ação (O quê?)", keyElemento = "acao", keyDetalhamento = "det_acao",
            placeholderElemento = "Ex: promover campanhas...", placeholderDetalhamento = "Ex: como a distribuição de...",
            sugestoesElemento = listOf("criar políticas públicas afirmativas e inclusivas", "destinar verbas públicas específicas para o setor", "endurecer as penas e aprimorar a fiscalização", "instituir frentes parlamentares de defesa", "subsidiar projetos sociais e ONGs atuantes na área", "incluir a discussão da temática na BNCC", "promover oficinas, minicursos e rodas de conversa", "desenvolver plataformas digitais gratuitas de auxílio", "ampliar a infraestrutura de acolhimento e suporte"),
            sugestoesDetalhamento = listOf("a exemplo da contratação de psicólogos e pedagogos", "como a construção de novos polos de atendimento e centros de referência", "abordando temas essenciais como empatia e direitos humanos", "a citar a distribuição de cartilhas físicas e materiais audiovisuais", "como a criação de um aplicativo gratuito e intuitivo"),
            tooltip = "O que será feito para resolver o problema?"
        ),
        PassoIntervencao(
            label = "3. Meio/Modo (Como?)", keyElemento = "meio", keyDetalhamento = "det_meio",
            placeholderElemento = "Ex: por meio de verbas...", placeholderDetalhamento = "Ex: utilizando tecnologias...",
            sugestoesElemento = listOf("mediante o redirecionamento de verbas provenientes da arrecadação de impostos", "através da consolidação de Parcerias Público-Privadas (PPPs)", "por meio de campanhas de amplo alcance veiculadas nas mídias de massa", "através de parcerias com influenciadores digitais e algoritmos de redes sociais", "por intermédio de projetos extracurriculares nas escolas", "mediante a promoção de debates liderados por especialistas"),
            sugestoesDetalhamento = listOf("com recursos provenientes de parcelas específicas da arrecadação estatal", "utilizando algoritmos de direcionamento em plataformas digitais", "utilizando a infraestrutura física das escolas aos finais de semana", "através de fundos arrecadados via incentivos fiscais para empresas", "mediante o uso de inteligência artificial e análise de dados"),
            tooltip = "Como a ação será executada na prática?"
        ),
        PassoIntervencao(
            label = "4. Efeito (Para quê?)", keyElemento = "efeito", keyDetalhamento = "det_efeito",
            placeholderElemento = "Ex: a fim de mitigar...", placeholderDetalhamento = "Ex: fato que garantirá...",
            sugestoesElemento = listOf("com o fito de reverter a atual negligência estatal sobre a questão", "a fim de desconstruir estigmas e preconceitos enraizados na sociedade", "com o intuito de democratizar o acesso à informação e aos direitos básicos", "para que a prerrogativa constitucional saia do papel e seja garantida na prática", "visando assegurar a dignidade da pessoa humana", "com o objetivo de construir um tecido social mais empático, crítico e igualitário"),
            sugestoesDetalhamento = listOf("o que garantirá a perpetuidade e sustentabilidade dessa mudança nas próximas gerações", "fazendo com que, finalmente, a garantia estipulada na Constituição deixe de ser uma utopia", "fato que culminará na redução drástica das estatísticas alarmantes vistas atualmente", "quebrando, de uma vez por todas, o ciclo de invisibilidade e negligência sobre o tema", "alinhando as práticas do Brasil aos Objetivos de Desenvolvimento Sustentável (ODS)"),
            tooltip = "Qual é a finalidade principal e o seu impacto a longo prazo?"
        )
    )

    fun limparDetalhamento(texto: String): String {
        return texto.removePrefix(",").removePrefix("—").trim()
    }

    val propostaGerada = remember(dadosFormulario.values.toList()) {
        val agente = dadosFormulario["agente"]?.trim() ?: ""
        val detAgente = dadosFormulario["det_agente"]?.trim() ?: ""
        val acao = dadosFormulario["acao"]?.trim() ?: ""
        val detAcao = dadosFormulario["det_acao"]?.trim() ?: ""
        val meio = dadosFormulario["meio"]?.trim() ?: ""
        val detMeio = dadosFormulario["det_meio"]?.trim() ?: ""
        val efeito = dadosFormulario["efeito"]?.trim() ?: ""
        val detEfeito = dadosFormulario["det_efeito"]?.trim() ?: ""

        if (agente.isNotBlank() && acao.isNotBlank() && meio.isNotBlank() && efeito.isNotBlank()) {
            val strAgente = if (detAgente.isNotBlank()) "$agente, ${limparDetalhamento(detAgente)}" else agente
            val strAcao = if (detAcao.isNotBlank()) "$acao, ${limparDetalhamento(detAcao)}" else acao
            val strMeio = if (detMeio.isNotBlank()) "$meio, ${limparDetalhamento(detMeio)}" else meio
            val strEfeito = if (detEfeito.isNotBlank()) "$efeito, ${limparDetalhamento(detEfeito)}" else efeito

            "Portanto, para mitigar essa problemática, é mister que o agente responsável — $strAgente — atue para $strAcao. Para isso, a intervenção deve ser viabilizada $strMeio, $strEfeito."
        } else ""
    }

    Scaffold(
        topBar = {
            CenterAlignedTopAppBar(
                title = { Text("Fórmula da C5", fontWeight = FontWeight.Bold, color = Color.White) },
                navigationIcon = { IconButton(onClick = aoClicarVoltar) { Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = null, tint = Color.White) } },
                colors = TopAppBarDefaults.centerAlignedTopAppBarColors(containerColor = corPrimaria)
            )
        }
    ) { padding ->
        Column(
            modifier = Modifier
                .padding(padding)
                .fillMaxSize()
                .background(Color(0xFFF5F7FA))
                .verticalScroll(scrollState)
                .padding(20.dp)
        ) {
            Row(Modifier.fillMaxWidth().padding(bottom = 24.dp), horizontalArrangement = Arrangement.Center) {
                passos.forEachIndexed { index, _ ->
                    Box(
                        modifier = Modifier
                            .size(10.dp)
                            .padding(horizontal = 2.dp)
                            .background(if (index <= passoAtual) corPrimaria else Color.LightGray, RoundedCornerShape(5.dp))
                    )
                }
            }

            val passo = passos[passoAtual]
            var mostrarDetalhamento by remember(passoAtual) { mutableStateOf(dadosFormulario[passo.keyDetalhamento]!!.isNotBlank()) }

            Card(
                colors = CardDefaults.cardColors(containerColor = Color.White),
                elevation = CardDefaults.cardElevation(2.dp),
                shape = RoundedCornerShape(16.dp),
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(Modifier.padding(20.dp)) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Text(passo.label, fontWeight = FontWeight.Bold, fontSize = 16.sp)
                        Spacer(Modifier.width(8.dp))
                        TooltipBox(passo.tooltip)
                    }

                    Spacer(Modifier.height(12.dp))

                    if (passo.keyElemento == "agente") {
                        FilledTonalButton(
                            onClick = aoClicarAbrirBancoAgentes,
                            modifier = Modifier.fillMaxWidth(),
                            colors = ButtonDefaults.filledTonalButtonColors(
                                containerColor = corPrimaria.copy(alpha = 0.1f),
                                contentColor = corPrimaria
                            )
                        ) {
                            Icon(Icons.Default.Search, contentDescription = null)
                            Spacer(Modifier.width(8.dp))
                            Text("Pesquisar no Banco de Agentes", fontWeight = FontWeight.Bold)
                        }
                        Spacer(Modifier.height(12.dp))
                    }

                    OutlinedTextField(
                        value = dadosFormulario[passo.keyElemento] ?: "",
                        onValueChange = { dadosFormulario[passo.keyElemento] = it },
                        modifier = Modifier.fillMaxWidth(),
                        placeholder = { Text(passo.placeholderElemento, fontSize = 14.sp) },
                        shape = RoundedCornerShape(12.dp)
                    )

                    if (passo.sugestoesElemento.isNotEmpty()) {
                        Spacer(Modifier.height(8.dp))
                        FlowRow(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            passo.sugestoesElemento.forEach { sugestao ->
                                SuggestionChip(onClick = { dadosFormulario[passo.keyElemento] = sugestao }, label = { Text(sugestao, fontSize = 12.sp) })
                            }
                        }
                    }

                    Spacer(Modifier.height(20.dp))
                    Divider(color = Color.LightGray.copy(alpha = 0.5f))
                    Spacer(Modifier.height(12.dp))

                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Text("Detalhamento (Opcional)", fontWeight = FontWeight.SemiBold, fontSize = 14.sp, color = Color.DarkGray)
                        TextButton(onClick = { mostrarDetalhamento = !mostrarDetalhamento }) {
                            Icon(Icons.Default.Add, contentDescription = null, modifier = Modifier.size(16.dp))
                            Spacer(Modifier.width(4.dp))
                            Text(if (mostrarDetalhamento) "Ocultar" else "Adicionar")
                        }
                    }

                    AnimatedVisibility(visible = mostrarDetalhamento) {
                        Column {
                            OutlinedTextField(
                                value = dadosFormulario[passo.keyDetalhamento] ?: "",
                                onValueChange = { dadosFormulario[passo.keyDetalhamento] = it },
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .height(100.dp),
                                placeholder = { Text(passo.placeholderDetalhamento, fontSize = 14.sp) },
                                shape = RoundedCornerShape(12.dp)
                            )
                            Spacer(Modifier.height(8.dp))
                            FlowRow(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                passo.sugestoesDetalhamento.forEach { sugestao ->
                                    SuggestionChip(onClick = { dadosFormulario[passo.keyDetalhamento] = sugestao }, label = { Text(sugestao, fontSize = 12.sp) })
                                }
                            }
                        }
                    }

                    Spacer(Modifier.height(24.dp))

                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                        TextButton(onClick = { if (passoAtual > 0) passoAtual-- }, enabled = passoAtual > 0) {
                            Icon(Icons.Rounded.ArrowBack, contentDescription = null)
                            Spacer(Modifier.width(4.dp))
                            Text("Anterior")
                        }

                        Button(
                            onClick = {
                                if (passoAtual < passos.size - 1) {
                                    passoAtual++
                                } else {
                                    val temAlgumDetalhamento = dadosFormulario["det_agente"]!!.isNotBlank() ||
                                            dadosFormulario["det_acao"]!!.isNotBlank() ||
                                            dadosFormulario["det_meio"]!!.isNotBlank() ||
                                            dadosFormulario["det_efeito"]!!.isNotBlank()

                                    if (!temAlgumDetalhamento) {
                                        println("⚠️ Cuidado! Você precisa detalhar pelo menos UM elemento para garantir os 200 pontos na C5.")
                                    } else {
                                        println("Proposta de Intervenção blindada!")
                                    }
                                }
                            },
                            colors = ButtonDefaults.buttonColors(containerColor = corPrimaria)
                        ) {
                            Text(if (passoAtual == passos.size - 1) "Finalizar" else "Próximo")
                            Spacer(Modifier.width(4.dp))
                            Icon(Icons.Rounded.ArrowForward, contentDescription = null)
                        }
                    }
                }
            }

            Spacer(Modifier.height(32.dp))

            Card(
                colors = CardDefaults.cardColors(containerColor = corPrimaria.copy(alpha = 0.05f)),
                border = BorderStroke(1.dp, corPrimaria.copy(alpha = 0.2f)),
                shape = RoundedCornerShape(16.dp),
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(Modifier.padding(20.dp)) {
                    Text("Sua Proposta de Intervenção", fontWeight = FontWeight.Bold, color = corPrimaria)
                    Spacer(Modifier.height(12.dp))
                    Box(
                        Modifier
                            .fillMaxWidth()
                            .background(Color.White, RoundedCornerShape(8.dp))
                            .padding(16.dp)
                    ) {
                        Text(
                            text = propostaGerada.ifBlank { "Preencha os passos para gerar sua proposta..." },
                            color = if (propostaGerada.isBlank()) Color.Gray else Color.Black,
                            fontSize = 15.sp,
                            lineHeight = 22.sp
                        )
                    }

                    if (propostaGerada.isNotBlank()) {
                        Spacer(Modifier.height(16.dp))
                        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            OutlinedButton(
                                onClick = {
                                    clipboardManager.setText(AnnotatedString(propostaGerada))
                                    println("Copiado!")
                                },
                                modifier = Modifier.weight(1f)
                            ) {
                                Icon(Icons.Default.ContentCopy, contentDescription = null, modifier = Modifier.size(18.dp))
                                Spacer(Modifier.width(8.dp))
                                Text("Copiar")
                            }

                            Button(
                                onClick = { aoEnviarParaCorrecao(propostaGerada) },
                                modifier = Modifier.weight(1f),
                                colors = ButtonDefaults.buttonColors(containerColor = corPrimaria)
                            ) {
                                Icon(Icons.AutoMirrored.Filled.Send, contentDescription = null, modifier = Modifier.size(18.dp))
                                Spacer(Modifier.width(8.dp))
                                Text("Corrigir na IA")
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun TooltipBox(mensagem: String) {
    var mostrar by remember { mutableStateOf(false) }
    IconButton(onClick = { mostrar = !mostrar }, modifier = Modifier.size(20.dp)) {
        Icon(Icons.Default.Info, contentDescription = null, tint = Color.Gray)
    }
    if (mostrar) {
        AlertDialog(
            onDismissRequest = { mostrar = false },
            text = { Text(mensagem) },
            confirmButton = {
                TextButton(onClick = { mostrar = false }) {
                    Text("Ok")
                }
            }
        )
    }
}

sealed class IntervencaoScreen {
    object Gerador : IntervencaoScreen()
    object BancoAgentes : IntervencaoScreen()
}

@Composable
fun TelaIntervencaoHost(
    isPremium: Boolean,
    aoClicarVoltar: () -> Unit,
    aoEnviarParaCorrecao: (String) -> Unit,
    corPrimaria: Color = Color(0xFF1E88E5)
) {
    var telaAtual by remember { mutableStateOf<IntervencaoScreen>(IntervencaoScreen.Gerador) }
    var agenteSelecionado by remember { mutableStateOf<String?>(null) }

    when (telaAtual) {
        IntervencaoScreen.Gerador -> {
            TelaGeradorIntervencao(
                aoClicarVoltar = aoClicarVoltar,
                aoClicarAbrirBancoAgentes = { telaAtual = IntervencaoScreen.BancoAgentes },
                aoEnviarParaCorrecao = aoEnviarParaCorrecao,
                agenteSelecionado = agenteSelecionado,
                corPrimaria = corPrimaria
            )
        }
        IntervencaoScreen.BancoAgentes -> {
            TelaAgentesIntervencao(
                aoClicarVoltar = { telaAtual = IntervencaoScreen.Gerador },
                aoClicarGerador = { telaAtual = IntervencaoScreen.Gerador },
                isPremium = isPremium,
                modoSelecao = true,
                aoSelecionarAgente = { agente ->
                    agenteSelecionado = agente
                    telaAtual = IntervencaoScreen.Gerador
                }
            )
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TelaAgentesIntervencao(
    aoClicarVoltar: () -> Unit,
    aoClicarGerador: () -> Unit,
    isPremium: Boolean,
    modoSelecao: Boolean = false,
    aoSelecionarAgente: ((String) -> Unit)? = null
) {
    val corPrimaria = MaterialTheme.colorScheme.primary
    val corFundo = MaterialTheme.colorScheme.background
    val corDestaque = MaterialTheme.colorScheme.tertiary
    val corTextoContraste = MaterialTheme.colorScheme.onPrimary

    var textoBusca by remember { mutableStateOf("") }
    var filtroTipo by remember { mutableStateOf<TipoAgente?>(null) }
    var filtroEixo by remember { mutableStateOf<EixoAgente?>(null) }

    val agentesFiltrados = BancoDeAgentes.listaAgentes.filter { agente ->
        val matchTexto = agente.nome.contains(textoBusca, ignoreCase = true) ||
                agente.sigla.contains(textoBusca, ignoreCase = true) ||
                agente.funcaoSocial.contains(textoBusca, ignoreCase = true)

        val matchTipo = filtroTipo == null || agente.tipo == filtroTipo
        val matchEixo = filtroEixo == null || agente.eixo == filtroEixo

        matchTexto && matchTipo && matchEixo
    }

    Scaffold(
        containerColor = corFundo,
        topBar = {
            CenterAlignedTopAppBar(
                title = {
                    Text(
                        "Agentes para intervenção",
                        fontWeight = FontWeight.Bold,
                        color = corTextoContraste
                    )
                },
                navigationIcon = {
                    IconButton(onClick = aoClicarVoltar) {
                        Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = null, tint = corTextoContraste)
                    }
                },
                colors = TopAppBarDefaults.centerAlignedTopAppBarColors(containerColor = corPrimaria)
            )
        },
        floatingActionButton = {
            ExtendedFloatingActionButton(
                onClick = aoClicarGerador,
                containerColor = corDestaque,
                contentColor = Color.White,
                icon = { Icon(Icons.Default.Edit, contentDescription = "Montar Proposta") },
                text = { Text("Montar Proposta C5", fontWeight = FontWeight.Bold) }
            )
        }
    ) { padding ->
        Column(modifier = Modifier.padding(padding)) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(Color.White)
                    .padding(16.dp)
            ) {
                OutlinedTextField(
                    value = textoBusca,
                    onValueChange = { textoBusca = it },
                    placeholder = {
                        Text("Buscar agente (Ex: MEC, ONGs...)", color = Color.DarkGray)
                    },
                    leadingIcon = {
                        Icon(Icons.Default.Search, contentDescription = null, tint = Color.DarkGray)
                    },
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(12.dp),
                    colors = OutlinedTextFieldDefaults.colors(
                        focusedBorderColor = corPrimaria,
                        unfocusedBorderColor = Color.LightGray,
                        focusedTextColor = Color.Black,
                        unfocusedTextColor = Color.Black,
                        cursorColor = corPrimaria
                    )
                )

                Spacer(modifier = Modifier.height(12.dp))

                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    FilterChip(
                        selected = filtroTipo == null,
                        onClick = { filtroTipo = null },
                        label = {
                            Text(
                                "Todos",
                                color = if (filtroTipo == null) corTextoContraste else Color.DarkGray
                            )
                        },
                        colors = FilterChipDefaults.filterChipColors(
                            containerColor = Color.LightGray.copy(alpha = 0.3f),
                            selectedContainerColor = corPrimaria,
                            selectedLabelColor = corTextoContraste
                        )
                    )
                    FilterChip(
                        selected = filtroTipo == TipoAgente.GOVERNAMENTAL,
                        onClick = {
                            filtroTipo = if (filtroTipo == TipoAgente.GOVERNAMENTAL) null else TipoAgente.GOVERNAMENTAL
                        },
                        label = {
                            Text(
                                "Governo",
                                color = if (filtroTipo == TipoAgente.GOVERNAMENTAL) corTextoContraste else Color.DarkGray
                            )
                        },
                        leadingIcon = {
                            Icon(
                                Icons.Rounded.AccountBalance,
                                contentDescription = null,
                                modifier = Modifier.size(16.dp),
                                tint = if (filtroTipo == TipoAgente.GOVERNAMENTAL) corTextoContraste else Color.DarkGray
                            )
                        },
                        colors = FilterChipDefaults.filterChipColors(
                            containerColor = Color.LightGray.copy(alpha = 0.3f),
                            selectedContainerColor = corPrimaria,
                            selectedLabelColor = corTextoContraste
                        )
                    )
                    FilterChip(
                        selected = filtroTipo == TipoAgente.NAO_GOVERNAMENTAL,
                        onClick = {
                            filtroTipo = if (filtroTipo == TipoAgente.NAO_GOVERNAMENTAL) null else TipoAgente.NAO_GOVERNAMENTAL
                        },
                        label = {
                            Text(
                                "ONGs/Sociedade",
                                color = if (filtroTipo == TipoAgente.NAO_GOVERNAMENTAL) corTextoContraste else Color.DarkGray
                            )
                        },
                        leadingIcon = {
                            Icon(
                                Icons.Rounded.Groups,
                                contentDescription = null,
                                modifier = Modifier.size(16.dp),
                                tint = if (filtroTipo == TipoAgente.NAO_GOVERNAMENTAL) corTextoContraste else Color.DarkGray
                            )
                        },
                        colors = FilterChipDefaults.filterChipColors(
                            containerColor = Color.LightGray.copy(alpha = 0.3f),
                            selectedContainerColor = corPrimaria,
                            selectedLabelColor = corTextoContraste
                        )
                    )
                }

                Spacer(modifier = Modifier.height(8.dp))

                LazyRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    item {
                        FilterChip(
                            selected = filtroEixo == null,
                            onClick = { filtroEixo = null },
                            label = {
                                Text(
                                    "Todas as Áreas",
                                    color = if (filtroEixo == null) corTextoContraste else Color.DarkGray
                                )
                            },
                            colors = FilterChipDefaults.filterChipColors(
                                containerColor = Color.LightGray.copy(alpha = 0.3f),
                                selectedContainerColor = corDestaque,
                                selectedLabelColor = Color.Black
                            )
                        )
                    }
                    items(EixoAgente.entries) { eixo ->
                        FilterChip(
                            selected = filtroEixo == eixo,
                            onClick = {
                                filtroEixo = if (filtroEixo == eixo) null else eixo
                            },
                            label = {
                                Text(
                                    eixo.nome,
                                    color = if (filtroEixo == eixo) Color.Black else Color.DarkGray
                                )
                            },
                            colors = FilterChipDefaults.filterChipColors(
                                containerColor = Color.LightGray.copy(alpha = 0.3f),
                                selectedContainerColor = corDestaque,
                                selectedLabelColor = Color.Black
                            )
                        )
                    }
                }
            }

            LazyColumn(
                contentPadding = PaddingValues(
                    start = 16.dp,
                    end = 16.dp,
                    top = 16.dp,
                    bottom = 100.dp
                ),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                items(agentesFiltrados) { agente ->
                    CardAgente(
                        agente = agente,
                        corTema = corPrimaria,
                        corTextoContraste = corTextoContraste,
                        modoSelecao = modoSelecao,
                        aoSelecionarAgente = aoSelecionarAgente
                    )
                }
            }
        }
    }
}

@Composable
fun CardAgente(
    agente: AgenteIntervencao,
    corTema: Color,
    corTextoContraste: Color,
    modoSelecao: Boolean = false,
    aoSelecionarAgente: ((String) -> Unit)? = null
) {
    Card(
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(2.dp),
        shape = RoundedCornerShape(12.dp),
        modifier = Modifier.fillMaxWidth()
    ) {
        Column {
            Row(modifier = Modifier.padding(16.dp)) {
                if (agente.imagemResId != null && agente.imagemResId != 0) {
                    Box(
                        modifier = Modifier
                            .size(60.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(Color.LightGray),
                        contentAlignment = Alignment.Center
                    ) {
                        Text(agente.nome.take(1), fontWeight = FontWeight.Bold, color = corTema, fontSize = 20.sp)
                    }
                } else {
                    Box(
                        modifier = Modifier
                            .size(60.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(corTema.copy(alpha = 0.1f)),
                        contentAlignment = Alignment.Center
                    ) {
                        Text(agente.nome.take(1), fontWeight = FontWeight.Bold, color = corTema, fontSize = 20.sp)
                    }
                }

                Spacer(modifier = Modifier.width(16.dp))

                Column {
                    SelectionContainer {
                        Text(
                            text = if (agente.sigla.isNotEmpty()) "${agente.nome} (${agente.sigla})" else agente.nome,
                            fontWeight = FontWeight.Bold,
                            fontSize = 16.sp,
                            color = Color.Black
                        )
                    }
                    Spacer(modifier = Modifier.height(4.dp))
                    Row(modifier = Modifier.horizontalScroll(rememberScrollState()), horizontalArrangement = Arrangement.Start) {
                        Surface(
                            color = if (agente.tipo == TipoAgente.GOVERNAMENTAL) corTema.copy(alpha = 0.1f) else Color(0xFFF3E5F5),
                            shape = RoundedCornerShape(4.dp)
                        ) {
                            SelectionContainer {
                                Text(
                                    text = if (agente.tipo == TipoAgente.GOVERNAMENTAL) "Governamental" else "Sociedade Civil",
                                    fontSize = 10.sp,
                                    fontWeight = FontWeight.Bold,
                                    color = if (agente.tipo == TipoAgente.GOVERNAMENTAL) corTema else Color(0xFF7B1FA2),
                                    modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp)
                                )
                            }
                        }
                        Spacer(modifier = Modifier.width(8.dp))
                        Surface(color = Color(0xFFFFF3E0), shape = RoundedCornerShape(4.dp)) {
                            SelectionContainer {
                                Text(
                                    text = agente.eixo.nome,
                                    fontSize = 10.sp,
                                    fontWeight = FontWeight.Bold,
                                    color = Color(0xFFE65100),
                                    modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp)
                                )
                            }
                        }
                    }
                }
            }

            Divider(color = Color.LightGray.copy(alpha = 0.2f))

            Column(modifier = Modifier.padding(16.dp)) {
                SelectionContainer {
                    Column {
                        Text("Função Social:", fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color.Black)
                        Text(agente.funcaoSocial, fontSize = 14.sp, color = Color.DarkGray)
                    }
                }
                Spacer(modifier = Modifier.height(12.dp))
                Surface(color = Color(0xFFF8F9FA), shape = RoundedCornerShape(8.dp), modifier = Modifier.fillMaxWidth()) {
                    SelectionContainer {
                        Column(modifier = Modifier.padding(12.dp)) {
                            Text("💡 Exemplo de ação:", fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color.Black)
                            Text(text = agente.exemploAcao, fontSize = 13.sp, fontStyle = FontStyle.Italic, color = Color.Black)
                        }
                    }
                }

                if (modoSelecao && aoSelecionarAgente != null) {
                    Spacer(modifier = Modifier.height(16.dp))
                    Button(
                        onClick = {
                            val textoFinal = if (agente.sigla.isNotEmpty()) "${agente.nome} (${agente.sigla})" else agente.nome
                            aoSelecionarAgente(textoFinal)
                        },
                        modifier = Modifier.fillMaxWidth(),
                        colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.tertiary)
                    ) {
                        Icon(Icons.Default.Check, contentDescription = null)
                        Spacer(Modifier.width(8.dp))
                        Text("Usar este Agente na Proposta", fontWeight = FontWeight.Bold)
                    }
                }
            }
        }
    }
}
